
import { basicUrl } from './config/config.js';

export async function getSubcategories(topLevelCatID) {
  const response = await fetch(`${basicUrl}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: `
        query getSubcategories {
          categories(first: 1000, where: {parent: ${topLevelCatID}}) {
            nodes {
              databaseId
              name
              link
            }
          }
        }
      `
    })
  });

  const data = await response.json();
  const subcats = data.data.categories.nodes;
  return subcats;
}



